import { defineMessage } from 'services/localization';

export const commonErrorMessages = {
    somethingWentWrong: defineMessage('oops_something_went_wrong_2'),
    twoFAMustBeEnabled: defineMessage('fa_must_be_enabled'),
    twoFAIsAlreadyEnabled: defineMessage('fa_is_already_enabled'),
    requestHasBeenUpdated: defineMessage('the_request_has_been_up_se_review_it_once_again'),
    invalidAttachment: defineMessage('the_attachment_is_invalid_and_cannot_be_attached'),
    invalidFileName: defineMessage('error_the_file_filename_cannot_be_attached'),
    restrictedFileName: defineMessage('the_attachment_file_nam_ted_substring_substring'),
    attachmentExceedsLimit: defineMessage('error_the_maximum_numbe__is_exceeded_cur_of_max'),
    xeroValidationError: defineMessage('xero_validation_error'),
    xeroError: defineMessage('xero_error_errormessage'),
    qboValidationError: defineMessage('quickbooks_online_validation_error'),
    qboError: defineMessage('quickbooks_online_validation_error_errormessage'),
    requiredFieldError: defineMessage('required_field_is_empty'),
    fileUploadLimitError: defineMessage('only_files_can_be_uploa_se_wait_seconds_seconds'),
    pdfFileProtectedError: defineMessage('the_pdf_file_filename_m__before_data_extraction'),
    ocrImageResolutionError: defineMessage('the_image_filename_heig_is_out_of_range_min_max'),
    ocrUnsupportedFileErrorMessage: defineMessage('file_type_extension_not__by_approvalmax_capture'),
    ocrUnsupportedFileErrorDescription: defineMessage('filename_is_not_support_oad_it_as_an_attachment'),
    loginWithPasskey: defineMessage('please_log_in_with_your_passkey_1'),
};

export const errorMessages = {
    error1002: defineMessage('sorry_the_file_upload_has_failed'),
    error2001: defineMessage('user_or_email_not_found'),
    error2002: defineMessage('user_or_email_not_found'),
    error2003: defineMessage('error_the_approval_was_not_found'),
    error2011: defineMessage('error_the_request_was_n_nd_or_access_was_denied'),
    error2013: defineMessage('you_are_no_longer_an_approver_in_this_step'),
    error2014: defineMessage('error_the_organisation_was_not_found'),
    error2016: defineMessage('error_the_integration_was_not_found'),
    error2020: defineMessage('error_the_report_was_not_found'),
    error3001: defineMessage('sorry_theres_an_authentication_error'),
    error3002: defineMessage('email_not_verified'),
    error3003: defineMessage('incorrect_email_or_password'),
    error3004: defineMessage('sorry_this_password_is__r_eg_br_use_a_symbol_eg'),
    error3005: defineMessage('sorry_this_password_is__ase_set_a_different_one'),
    error3007: defineMessage('sorry_the_maximum_numbe_se_try_again_in_minutes'),
    error3009: defineMessage('invalid_old_password'),
    error4002: defineMessage('wrong_confirmation_code'),
    error4004: defineMessage('error_the_new_password_field_is_empty'),
    error4036: defineMessage('error_the_approval_work_least_one_approval_step'),
    error4042: defineMessage('administrators_cannot_r_s_from_the_organisation'),
    error4043: defineMessage('the_organisation_connec_nnect_your_organisation'),
    error4045: defineMessage('error_there_are_no_active_subscriptions'),
    error4046: defineMessage('error_the_subscription_expired'),
    error4047: defineMessage('the_allowed_number_of_o_iption_has_been_reached'),
    error4048: defineMessage('the_request_has_been_ch_iew_and_make_a_decision'),
    error4049: defineMessage('error_the_organisations__list_of_administrators'),
    error4055: defineMessage('sorry_you_have_no_access_to_this_request'),
    error4067: defineMessage('you_cannot_set_a_delega_y_a_delegate_themselves'),
    error4075: defineMessage('the_request_has_been_rejected_by_xero'),
    error4076: defineMessage('sorry_the_maximum_numbe_oaded_files_is_exceeded'),
    error4077: defineMessage('sorry_too_many_files_ar_se_try_again_in_minutes'),
    error4078: defineMessage('sorry_the_file_filename__the_maximum_size_of_mb'),
    error4079: defineMessage('sorry_the_file_type_of__due_to_security_reasons'),
    error4080: defineMessage('sorry_the_file_filename_hat_it_contains_a_virus'),
    error4081: defineMessage('error_confirmation_code_expired'),
    error4082: defineMessage('error_the_integration_e_ate_is_beyond_the_limit'),
    error4083: defineMessage('error_the_integration_e_e_date_has_not_been_set'),
    error4132: defineMessage('fa_is_already_enabled'),
    error4181: defineMessage('fa_must_be_enabled_1'),
    error5001: defineMessage('error_theres_a_general_integration_error'),
    error5002: defineMessage('error_the_xero_api_must_be_authorised'),
    error5003: defineMessage('error_the_oauth_token_has_expired'),
    error5004: defineMessage('error_the_oauth_token_is_not_authorised'),
    error5005: defineMessage('error_the_request_token_lookup_has_failed'),
    error5006: defineMessage('error_the_request_token_key_does_not_match'),
    error5007: defineMessage('error_the_access_token_store_was_not_initialised'),
    error5008: defineMessage('error_the_access_token_was_not_found'),
    error5009: defineMessage('error_the_renewal_token_is_prohibited'),
    error5010: defineMessage('error_the_callback_url_must_be_specified'),
    error5011: defineMessage('error_the_oauth_token_must_be_specified'),
    error5012: defineMessage('error_the_oauth_verifier_must_be_specified'),
    error5013: defineMessage('errordetail_please_try__nklearn_moresupportlink'),
    error5014: defineMessage('error_the_oauth_token_was_rejected'),
    error5015: defineMessage('error_theres_a_general__on_authentication_error'),
    error5018: defineMessage('the_request_has_been_up_se_review_it_once_again_1'),
    error5019: defineMessage('this_document_can_not_b_organisations_lock_date'),
    error5020: defineMessage('error_xero_is_unavailable_please_try_again_later'),
    error7002: defineMessage('error_the_quickbooks_on_nisations_administrator'),
    error7029: defineMessage('action_unavailable_the__tatus_cannot_be_updated'),
    error7030: defineMessage('action_unavailable_the___please_try_again_later'),
    error4142: defineMessage('some_data_has_changed_i_the_offboarding_process'),
    error4183: defineMessage('debit_and_credit_amounts_are_not_equal_1'),
    error4177: defineMessage('too_many_lines_were_added_to_the_request'),
    error2018: defineMessage('line_item_is_not_found'),
    error7031: defineMessage('you_can_only_use_one_currency_per_journal_entry'),
    error4186: defineMessage('accounts_payable_ap_acc_endor_in_the_type_field_1'),
    error4187: defineMessage('accounts_receivable_ar__tomer_in_the_type_field_1'),
    error4188: defineMessage('the_currencies_of_your__and_vendor_must_be_same'),
    error4189: defineMessage('the_currencies_of_your__d_customer_must_be_same'),
    error6009: defineMessage('audit_reports_archive_is_already_being_prepared'),
    error6010: defineMessage('audit_reports_archive_h_en_sent_to_you_by_email'),
    error6011: defineMessage('there_are_no_audit_repo_ng_the_specified_filter'),
    error6012: defineMessage('the_attachment_archive__en_sent_to_you_by_email'),
    error6013: defineMessage('the_attachment_archive_is_already_being_prepared_1'),
    error4113: defineMessage('the_organisation_is_retired'),
    error4008: defineMessage('youve_already_signed_up_og_in_or_reset_password'),
    error4001: defineMessage('password_is_not_set'),
    error4109: defineMessage('required_fields_are_empty_fieldlist'),
};
